// extracted by mini-css-extract-plugin
module.exports = {"base":"HowCard_base__vDO8V","title":"HowCard_title__1JrnN","img":"HowCard_img__1ux4U","desc":"HowCard_desc__lZJkR","dark":"HowCard_dark__3iOrq"};